/**
 * @class
 * @description
 * Display the SVG workflow icon
 * @example
 *   Usage:
 *   <wf-icon color="'COLOR'"></wf-icon>
 *   <wf-icon multiple></wf-icon>
 *
 *   <wf-icon color="'red'"></wf-icon>
 *   <wf-icon multiple></wf-icon>
 */
export default class WfIconController {
	#$attrs;

	/* @ngInject */
	/**
	 * @param {import('angular').IAttributes} $attrs
	 */
	constructor($attrs) {
		this.#$attrs = $attrs;
		this.color = undefined;
		this.multiple = undefined;
	}

	$onInit() {
		this.multiple = this.#$attrs.multiple !== undefined && this.#$attrs.multiple !== 'false';
	}
}
